<template>
  <div class="document-section">
    <div class="toolbar">
      <div class="actions">
        <b-button size="sm" @click="toggleExpand">
          <fa icon="chevron-down" v-if="isExpanded"></fa>
          <fa icon="chevron-right" v-else></fa>
        </b-button>
        <b-button size="sm" @click="toggleEdit"><fa icon="bars"></fa></b-button>

        <h4 class="title">{{title}}</h4>
      </div>

      <div class="properties" v-if="isEditing">
        <attribute-editor
          :attributes="obj.attributes"
          @changed="attributesChanged"
        ></attribute-editor>
      </div>
    </div>

    <div class="body" v-if="isExpanded">
      <template
        v-for="(row, i) in obj.children"
      >
        <b-button size="sm" @click="addRow(i)" class="add-button" :key="i"><fa icon="plus"></fa></b-button>

        <row-container
          :key="row.id"
          :id="row.id"
          :obj="row"
          :index="i"
          :sibling-count="obj.children.length"
          :substitution-tags="substitutionTags"
          @move-up="moveUp"
          @move-down="moveDown"
          @remove-row="removeRow"
        ></row-container>
      </template>

      <b-button size="sm" @click="addRow" class="add-button"><fa icon="plus"></fa></b-button>
    </div>
  </div>
</template>

<script>
import * as elements from './elements'
import RowContainer from './RowContainer'
import AttributeEditor from './AttributeEditor'

const arrayMove = (arr, from, to) => arr.splice(to, 0, arr.splice(from, 1)[0])

export default {
  name: 'DocumentSection',

  components: {
    RowContainer,
    AttributeEditor
  },

  props: [
    'obj',
    'title',
    'expanded',
    'substitutionTags'
  ],

  data() {
    return {
      isEditing: false,
      isExpanded: !!this.expanded
    }
  },

  methods: {
    toggleEdit() {
      this.isEditing = !this.isEditing
    },

    toggleExpand() {
      this.isExpanded = !this.isExpanded
    },

    addRow(i) {
      let row = new elements.RowContainer([
        new elements.ColumnContainer()
      ])

      if (typeof i === 'number') {
        this.obj.children.splice(i, 0, row)
      } else {
        this.obj.children.push(row)
      }
    },

    removeRow(i) {
      if (confirm('Are you sure you want to remove this row?')) {
        this.obj.children.splice(i, 1)
      }
    },

    moveUp(i) {
      if (i > 0) {
        arrayMove(this.obj.children, i, i - 1)
      }
    },

    moveDown(i) {
      if (i < this.obj.children.length - 1) {
        arrayMove(this.obj.children, i, i + 1)
      }
    },

    attributesChanged(val) {
      this.obj.attributes = val
    }
  }
}
</script>

<style scoped>
  .document-section {
    position: relative;
    width: 100%;

    /*border: solid 1px #CCC;*/
    /*border-radius: 5px;*/
  }

  .document-section + .document-section {
    margin-top: 10px;
  }

  .toolbar {
    padding: 5px;

    border-bottom: solid 1px #CCC;
    background: #333;
    color: #FFF;
  }

  .actions {
    display: flex;
  }

  .actions > * + * {
    margin-left: 5px;
  }

  .row-container {
    width: 100%;
  }

  .body {
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 20px 0 5px;
  }

  .title {
    display: inline-block;
    margin: 0 0 0 10px;
    vertical-align: middle;

    color: #FFF;
  }

  .add-button {
    height: 30px;
    width: 30px;
    margin: -7px auto;
    z-index: 100;
    position: relative;
    top: -5px;
  }
</style>
